import { ElementRef, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../../../shared/base.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from '../../session.service';
import { SessionStorageService } from 'ngx-webstorage';
import { ResourceForHelpService } from '../../../resource-for-help/resource-for-help.service';
import { MessageService } from '../../../message/message.service';
import { UserService } from '../../../../core/user/user.service';
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CoachSlotService } from '../../../slot/coach-slot.service';
import { AccountService } from '../../../../core/auth/account.service';
import { CoachDetailsService } from '../../../slot/coach-details.service';
import { CancelSessionDialogComponent } from '../../../session/cancel-session-dialog/cancel-session-dialog.component';
import { TrackerService } from '../../../../core/tracker/tracker.service';
import { DataSharingConsentService } from '../../../data-sharing-consent/data-sharing-consent.service';
import { OrganizationResourcesComponent } from '../../../organization-resources/organization-resources.component';
import { UserInteractionService } from '../../../user-interaction/user-interaction.service';
import { LeaveNumberModalComponent } from '../../../login/leave-number-modal.component';
import { UserOrganizationCodeService } from '../../../user-organization-code/user-organization-code.service';
import { OrganizationResourceService } from '../../../../admin/organization-resource/organization-resource.service';
import { VideoCallService } from '../../../video-call/video-call.service';
import { JhiAlertService, JhiEventManager } from '../../../../ng-jhipster/service';
import { JhiLanguageService } from '../../../../ng-jhipster/language';
import * as i0 from "@angular/core";
import * as i1 from "../../session.service";
import * as i2 from "../../../message/message.service";
import * as i3 from "ngx-webstorage";
import * as i4 from "../../../resource-for-help/resource-for-help.service";
import * as i5 from "../../../../core/user/user.service";
import * as i6 from "@ng-bootstrap/ng-bootstrap";
import * as i7 from "../../../../ng-jhipster/service";
import * as i8 from "@ngx-translate/core";
import * as i9 from "@angular/router";
import * as i10 from "../../../slot/coach-slot.service";
import * as i11 from "../../../slot/coach-details.service";
import * as i12 from "../../../../core/auth/account.service";
import * as i13 from "../../../../core/tracker/tracker.service";
import * as i14 from "../../../data-sharing-consent/data-sharing-consent.service";
import * as i15 from "../../../user-interaction/user-interaction.service";
import * as i16 from "../../../user-organization-code/user-organization-code.service";
import * as i17 from "../../../../ng-jhipster/language";
import * as i18 from "../../../../admin/organization-resource/organization-resource.service";
import * as i19 from "../../../video-call/video-call.service";
import * as i20 from "@angular/common";
import * as i21 from "../../../../shared/auth/has-any-authority.directive";
import * as i22 from "@fortawesome/angular-fontawesome";
import * as i23 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i24 from "../../schedule-session/schedule-session-coach/schedule-session-coach.component";
import * as i25 from "../../../../shared/resources-for-help/resources-for-help.component";
import * as i26 from "@angular/forms";
import * as i27 from "../../../../shared/auto-direction-switch/input-auto-direction-switch.directive";
import * as i28 from "../../../../shared/modal-success/modal-success.component";
const _c0 = ["resourcesForHelpModal"];
const _c1 = ["reportClientModal"];
const _c2 = ["askToShareOrganizationResources"];
function SessionControlDropdownComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 11);
    i0.ɵɵelement(2, "fa-icon", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 13);
    i0.ɵɵelement(4, "fa-icon", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SessionControlDropdownComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 14);
    i0.ɵɵelement(2, "fa-icon", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SessionControlDropdownComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 15);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_5_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.openReportCoachModal(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 16);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_5_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.displayResourcesModal(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function SessionControlDropdownComponent_ng_container_6_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_6_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(2); const _r4 = i0.ɵɵreference(8); ctx_r24.open(_r4); return ctx_r24.logBookSession(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("opacity", (ctx_r17.coachee == null ? null : ctx_r17.coachee.credits) === 0 ? 0.5 : 1);
    i0.ɵɵproperty("disabled", (ctx_r17.coachee == null ? null : ctx_r17.coachee.credits) === 0);
} }
function SessionControlDropdownComponent_ng_container_6_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_6_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.cancelSession(ctx_r26.session.id, "reschedule"); });
    i0.ɵɵelementEnd();
} }
function SessionControlDropdownComponent_ng_container_6_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_6_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(2); return ctx_r28.cancelSession(ctx_r28.session.id, "cancel"); });
    i0.ɵɵelementEnd();
} }
function SessionControlDropdownComponent_ng_container_6_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 29);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_6_ng_container_4_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.startVideoCall(); });
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵelement(3, "img", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 32);
    i0.ɵɵelement(5, "span", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 34);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_6_ng_container_4_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.startZoomVideoChat(); });
    i0.ɵɵelementStart(7, "div", 30);
    i0.ɵɵelement(8, "img", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "span", 36);
    i0.ɵɵelement(10, "span", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 38);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_6_ng_container_4_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r31); const ctx_r33 = i0.ɵɵnextContext(2); return ctx_r33.startJitsiVideoChat(); });
    i0.ɵɵelementStart(12, "div", 30);
    i0.ɵɵelement(13, "img", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "span", 40);
    i0.ɵɵelement(15, "span", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
const _c3 = function (a0) { return { "disabled": a0 }; };
function SessionControlDropdownComponent_ng_container_6_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 41);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_6_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.extendSessionByTenMinutes(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c3, ctx_r21.session.minutesLeftToSessionEnd === 0));
} }
function SessionControlDropdownComponent_ng_container_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 42);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_6_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(2); const _r6 = i0.ɵɵreference(10); return ctx_r36.open(_r6); });
    i0.ɵɵelementEnd();
} }
const _c4 = function (a0) { return { "dropdown-item-disabled": a0 }; };
function SessionControlDropdownComponent_ng_container_6_a_10_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 43);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_6_a_10_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(2); return ctx_r38.displayOrganisationResourcesModal(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c4, !ctx_r23.isCoachAllowedToSeeOrganizationResources));
} }
function SessionControlDropdownComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 17);
    i0.ɵɵtemplate(1, SessionControlDropdownComponent_ng_container_6_button_1_Template, 1, 3, "button", 18);
    i0.ɵɵtemplate(2, SessionControlDropdownComponent_ng_container_6_button_2_Template, 1, 0, "button", 19);
    i0.ɵɵtemplate(3, SessionControlDropdownComponent_ng_container_6_button_3_Template, 1, 0, "button", 20);
    i0.ɵɵtemplate(4, SessionControlDropdownComponent_ng_container_6_ng_container_4_Template, 16, 0, "ng-container", 2);
    i0.ɵɵtemplate(5, SessionControlDropdownComponent_ng_container_6_button_5_Template, 1, 3, "button", 21);
    i0.ɵɵtemplate(6, SessionControlDropdownComponent_ng_container_6_button_6_Template, 1, 0, "button", 22);
    i0.ɵɵelementStart(7, "button", 23);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_6_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.sendSelfScan(); });
    i0.ɵɵtext(8, "Send self scan link");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 24);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_container_6_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.displayResourcesModal(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, SessionControlDropdownComponent_ng_container_6_a_10_Template, 1, 3, "a", 25);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.session.statusOfSession === "ENDED" && !ctx_r3.hideCancelReschedule);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.session.minutesLeftToSessionStart >= 24 * 60 && !ctx_r3.hideCancelReschedule);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.session.minutesLeftToSessionStart >= 24 * 60 && !ctx_r3.hideCancelReschedule);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.session.started && (ctx_r3.coachDetails == null ? null : ctx_r3.coachDetails.videoChatEnabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.session.started);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.session.started);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r3.areAnyOrganizationResourcesExistForUser);
} }
function SessionControlDropdownComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelementStart(1, "fa-icon", 45);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_template_7_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 46);
    i0.ɵɵelementStart(3, "div", 47);
    i0.ɵɵelementStart(4, "div", 48);
    i0.ɵɵelement(5, "h3", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 50);
    i0.ɵɵelementStart(7, "div", 51);
    i0.ɵɵelementStart(8, "schedule-session-coach", 52);
    i0.ɵɵlistener("onCancel", function SessionControlDropdownComponent_ng_template_7_Template_schedule_session_coach_onCancel_8_listener() { i0.ɵɵrestoreView(_r45); const ctx_r46 = i0.ɵɵnextContext(); return ctx_r46.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("coach", ctx_r5.session.coach)("user", ctx_r5.session.user)("sessionLanguage", ctx_r5.session == null ? null : ctx_r5.session.langKey);
} }
function SessionControlDropdownComponent_ng_template_9_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵelementStart(1, "div", 55);
    i0.ɵɵelementStart(2, "fa-icon", 56);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_template_9_div_0_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r50); const ctx_r49 = i0.ɵɵnextContext(2); return ctx_r49.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 57);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelement(5, "h3", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelement(8, "p", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 60);
    i0.ɵɵelementStart(10, "button", 61);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_template_9_div_0_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r50); const ctx_r51 = i0.ɵɵnextContext(2); return ctx_r51.endSession(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 62);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_template_9_div_0_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r50); const ctx_r52 = i0.ɵɵnextContext(2); return ctx_r52.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SessionControlDropdownComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SessionControlDropdownComponent_ng_template_9_div_0_Template, 12, 0, "div", 53);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r7.ended);
} }
function SessionControlDropdownComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵelementStart(1, "div", 55);
    i0.ɵɵelementStart(2, "fa-icon", 56);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_template_11_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(); return ctx_r54.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 64);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelement(5, "h3", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelement(8, "p", 66);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 60);
    i0.ɵɵelementStart(10, "button", 67);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_template_11_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r55); const ctx_r56 = i0.ɵɵnextContext(); return ctx_r56.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 68);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_template_11_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r55); const ctx_r57 = i0.ɵɵnextContext(); return ctx_r57.askToShare(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SessionControlDropdownComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵelementStart(1, "div", 55);
    i0.ɵɵelementStart(2, "fa-icon", 70);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_template_13_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r60); const ctx_r59 = i0.ɵɵnextContext(); return ctx_r59.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 71);
    i0.ɵɵelementStart(4, "resources-for-help", 72);
    i0.ɵɵlistener("resourceSelected", function SessionControlDropdownComponent_ng_template_13_Template_resources_for_help_resourceSelected_4_listener($event) { i0.ɵɵrestoreView(_r60); const ctx_r61 = i0.ɵɵnextContext(); return ctx_r61.onResourceSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("user", ctx_r11.session.user);
} }
function SessionControlDropdownComponent_ng_template_15_div_0_small_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "small", 81);
} }
function SessionControlDropdownComponent_ng_template_15_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 75);
    i0.ɵɵelementStart(1, "div", 76);
    i0.ɵɵelement(2, "h3", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "textarea", 78);
    i0.ɵɵlistener("ngModelChange", function SessionControlDropdownComponent_ng_template_15_div_0_Template_textarea_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r67); const ctx_r66 = i0.ɵɵnextContext(2); return ctx_r66.reasonOfFlagging = $event; });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, SessionControlDropdownComponent_ng_template_15_div_0_small_7_Template, 1, 0, "small", 79);
    i0.ɵɵelement(8, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 47);
    i0.ɵɵelementStart(10, "button", 80);
    i0.ɵɵlistener("click", function SessionControlDropdownComponent_ng_template_15_div_0_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r67); const ctx_r68 = i0.ɵɵnextContext(2); return ctx_r68.reportClient(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r63 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(6, 3, "sessionChat.placeholder.enter"));
    i0.ɵɵproperty("ngModel", ctx_r63.reasonOfFlagging);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r63.showReasonOfFlaggingRequired);
} }
function SessionControlDropdownComponent_ng_template_15_modal_success_1_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "modal-success", 82);
    i0.ɵɵlistener("dismissed", function SessionControlDropdownComponent_ng_template_15_modal_success_1_Template_modal_success_dismissed_0_listener($event) { i0.ɵɵrestoreView(_r70); const ctx_r69 = i0.ɵɵnextContext(2); return ctx_r69.onDismiss($event); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r64 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("titleText", "sessionChat.title.done")("message", i0.ɵɵpipeBind1(1, 2, ctx_r64.reportSuccessMessage));
} }
function SessionControlDropdownComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SessionControlDropdownComponent_ng_template_15_div_0_Template, 11, 5, "div", 73);
    i0.ɵɵtemplate(1, SessionControlDropdownComponent_ng_template_15_modal_success_1_Template, 2, 4, "modal-success", 74);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r13.flagged);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.flagged);
} }
export class SessionControlDropdownComponent extends BaseComponent {
    constructor(sessionService, messageService, sessionStorage, resourceForHelpService, userService, modalService, alertService, translate, router, coachSlotService, coachDetailsService, accountService, trackerService, eventManager, dataSharingConsentService, userInteractionService, ngbModal, userOrganizationCodeService, languageService, organizationResourceService, videoCallService) {
        super(sessionStorage, modalService);
        this.sessionService = sessionService;
        this.messageService = messageService;
        this.sessionStorage = sessionStorage;
        this.resourceForHelpService = resourceForHelpService;
        this.userService = userService;
        this.modalService = modalService;
        this.alertService = alertService;
        this.translate = translate;
        this.router = router;
        this.coachSlotService = coachSlotService;
        this.coachDetailsService = coachDetailsService;
        this.accountService = accountService;
        this.trackerService = trackerService;
        this.eventManager = eventManager;
        this.dataSharingConsentService = dataSharingConsentService;
        this.userInteractionService = userInteractionService;
        this.ngbModal = ngbModal;
        this.userOrganizationCodeService = userOrganizationCodeService;
        this.languageService = languageService;
        this.organizationResourceService = organizationResourceService;
        this.videoCallService = videoCallService;
        this.resourceSelected = new EventEmitter();
        this.isFiltered = false;
        this.isCoachAllowedToSeeOrganizationResources = false;
        this.langKey = this.languageService.getCurrentLanguage() ? this.languageService.getCurrentLanguage() : "en";
        this.reasonOfFlagging = '';
        this.flagged = false;
    }
    ngOnInit() {
        console.log(this.session);
        this.userCountry = this.session.user.country;
        this.coachee = this.session.user;
        if (this.accountService.isCoach()) {
            this.organizationResourceService.areAnyOrganizationResourcesExistByUserIdAndLangKey(this.session.user.id, this.langKey).subscribe(res2 => {
                this.areAnyOrganizationResourcesExistForUser = res2.body;
                this.checkIsCoachAllowedToSeeOrganizationResources();
            });
            this.coachDetailsService.findCoachDetails(this.session.coachId).subscribe(res => {
                this.coachDetails = res.body;
            });
            this.eventManager.subscribe('userInteractionFinishedForConsentToShareOrganizationResource', () => {
                this.checkIsCoachAllowedToSeeOrganizationResources();
            });
        }
    }
    checkIsCoachAllowedToSeeOrganizationResources() {
        if (this.areAnyOrganizationResourcesExistForUser) {
            this.dataSharingConsentService.find("ORGANIZATION_RESOURCE" /* ORGANIZATION_RESOURCE */, this.session.user.id).subscribe(dataSharingConsent => {
                if (dataSharingConsent === null || dataSharingConsent === void 0 ? void 0 : dataSharingConsent.body.consented) {
                    this.isCoachAllowedToSeeOrganizationResources = true;
                }
            });
        }
    }
    displayOrganisationResourcesModal() {
        if (this.isCoachAllowedToSeeOrganizationResources) {
            const modalRef = this.modalService.open(OrganizationResourcesComponent, { size: "lg", centered: true });
            modalRef.componentInstance.isPopup = true;
            modalRef.componentInstance.userId = this.session.user.id;
            modalRef.componentInstance.organizationResourcesModalRef = modalRef;
        }
        else {
            this.modalService.open(this.askToShareOrganizationResources, { size: "md", centered: true });
        }
    }
    askToShare() {
        this.userInteractionService.startUserInteraction("CONSENT_TO_SHARE_ORGANIZATION_RESOURCE", this.session.user.id).subscribe(res => {
            console.log(res);
            this.dismissAll();
            const modalRef = this.ngbModal.open(LeaveNumberModalComponent, { size: 'md', centered: true });
            modalRef.componentInstance.leaveNumberModalRef = modalRef;
            modalRef.componentInstance.displayNLHelpHeader = false;
            modalRef.componentInstance.errorMessage = "sessionChat.header.sent";
        });
    }
    logBookSession() {
        this.trackerService.sendActivity("session_chat_booksession_btn_clicked");
    }
    cancelSession(sessionId, type) {
        const modalRef = this.modalService.open(CancelSessionDialogComponent, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.sessionId = sessionId;
        modalRef.componentInstance.type = type;
    }
    endSession() {
        this.sessionService.endSession(this.session.id).subscribe(() => {
            this.ended = true;
            this.modalService.dismissAll();
        });
    }
    isCoach() {
        var _a;
        const retrieve = this.sessionStorage.retrieve('id');
        return ((_a = this.session) === null || _a === void 0 ? void 0 : _a.coachId) === retrieve;
    }
    extendSessionByTenMinutes() {
        this.sessionService.extendSession(this.session.id).subscribe(s => {
            this.session = s;
        });
    }
    displayResourcesModal() {
        this.modalService.open(this.resourcesForHelpModal, { windowClass: 'resources-for-help-modal' });
    }
    reportClient() {
        this.showReasonOfFlaggingRequired = false;
        this.flagged = false;
        if (this.reasonOfFlagging === '') {
            this.showReasonOfFlaggingRequired = true;
            return;
        }
        this.userService.reportClient({ id: this.session.user.id, reasonOfFlagging: this.reasonOfFlagging }, this.session.id).subscribe(() => {
            this.flagged = true;
        }, error => console.error('client cannot be flagged: ' + error));
    }
    onDismiss($event) {
        console.log($event);
        this.flagged = false;
    }
    openReportCoachModal() {
        this.reportSuccessMessage = 'sessionChat.messages.coachIsFlagged';
        this.modalService.open(this.reportClientModal);
    }
    openReportClientModal() {
        this.reportSuccessMessage = 'sessionChat.messages.clientIsFlagged';
        this.modalService.open(this.reportClientModal);
    }
    startVideoCall() {
        this.videoCallService.startVideoCall(this.session).subscribe(value => {
            this.router.navigate(['/session/video-coach', this.session.id]).then();
        }, errorResponse => {
            let error = errorResponse.error;
            let errorText = this.translate.instant(error.errorKey);
            alert(errorText);
        });
    }
    startZoomVideoChat() {
        this.messageService.startZoomVideoChat(this.session.id).subscribe(value => {
            console.log(value);
        }, errorResponse => {
            let error = errorResponse.error;
            let errorText = this.translate.instant(error.errorKey);
            alert(errorText);
        });
    }
    startJitsiVideoChat() {
        this.messageService.startJitsiVideoChat(this.session.id).subscribe(value => {
            console.log(value);
        }, errorResponse => {
            let error = errorResponse.error;
            let errorText = this.translate.instant(error.errorKey);
            alert(errorText);
        });
    }
    sendSelfScan() {
        // let selfScan = {
        //   message: '<a href="/#/wellbeing-start" target="_blank">' + this.translate.instant('sessionChat.button.selfScan') + '</a>',
        //   sessionId: this.session.id,
        //   type: 'text'
        // };
        this.messageService.startWellbeingScan(this.session.user.id, this.session.id).subscribe(() => this.alertService.info('inukaNgApp.session.selfScanSent'), () => console.log('fail'));
    }
    showResource(index) {
        if (this.selectedIndex !== index) {
            this.selectedIndex = index;
        }
        else {
            this.selectedIndex = null;
        }
    }
    onResourceSelected($event) {
        this.resourceSelected.emit({ resource: $event.resource });
    }
}
SessionControlDropdownComponent.ɵfac = function SessionControlDropdownComponent_Factory(t) { return new (t || SessionControlDropdownComponent)(i0.ɵɵdirectiveInject(i1.SessionService), i0.ɵɵdirectiveInject(i2.MessageService), i0.ɵɵdirectiveInject(i3.SessionStorageService), i0.ɵɵdirectiveInject(i4.ResourceForHelpService), i0.ɵɵdirectiveInject(i5.UserService), i0.ɵɵdirectiveInject(i6.NgbModal), i0.ɵɵdirectiveInject(i7.JhiAlertService), i0.ɵɵdirectiveInject(i8.TranslateService), i0.ɵɵdirectiveInject(i9.Router), i0.ɵɵdirectiveInject(i10.CoachSlotService), i0.ɵɵdirectiveInject(i11.CoachDetailsService), i0.ɵɵdirectiveInject(i12.AccountService), i0.ɵɵdirectiveInject(i13.TrackerService), i0.ɵɵdirectiveInject(i7.JhiEventManager), i0.ɵɵdirectiveInject(i14.DataSharingConsentService), i0.ɵɵdirectiveInject(i15.UserInteractionService), i0.ɵɵdirectiveInject(i6.NgbModal), i0.ɵɵdirectiveInject(i16.UserOrganizationCodeService), i0.ɵɵdirectiveInject(i17.JhiLanguageService), i0.ɵɵdirectiveInject(i18.OrganizationResourceService), i0.ɵɵdirectiveInject(i19.VideoCallService)); };
SessionControlDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SessionControlDropdownComponent, selectors: [["session-control-dropdown"]], viewQuery: function SessionControlDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resourcesForHelpModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reportClientModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.askToShareOrganizationResources = _t.first);
    } }, inputs: { session: "session", hideCancelReschedule: "hideCancelReschedule" }, outputs: { resourceSelected: "resourceSelected" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 17, vars: 4, consts: [["ngbDropdown", "", "placement", "bottom-right", 1, "d-inline-block", "float-right", "olha-theme"], ["ngbDropdownToggle", "", "id", "session-info-dd-toggle"], [4, "ngIf"], ["ngbDropdownMenu", "", "aria-labelledby", "actionsMenu", 1, "dropdown-menu"], [4, "jhiHasAnyAuthority"], ["class", "dropdown-menu dropdown-menu-right", 4, "jhiHasAnyAuthority"], ["scheduleSessionModal", ""], ["endSessionModal", ""], ["askToShareOrganizationResources", ""], ["resourcesForHelpModal", ""], ["reportClientModal", ""], [1, "d-none", "d-lg-block", "horizontal-menu"], ["icon", "ellipsis-v"], [1, "d-lg-none", "vertical-menu"], [1, "ml-2", "mr-2"], ["id", "session-info-dd-report-coach", "jhiTranslate", "sessionChat.button.reportCoach", 1, "dropdown-item", 3, "click"], ["id", "session-info-dd-resource-for-help", "jhiTranslate", "sessionChat.button.resources", 1, "dropdown-item", 3, "click"], [1, "dropdown-menu", "dropdown-menu-right"], ["class", "dropdown-item", "jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.bookASession", 3, "disabled", "opacity", "click", 4, "ngIf"], ["class", "dropdown-item", "jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.reschedule", 3, "click", 4, "ngIf"], ["class", "dropdown-item", "jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.cancel", 3, "click", 4, "ngIf"], ["id", "session-info-dd-extend-session", "class", "dropdown-item d-xl-none", "jhiTranslate", "sessionChat.button.extend", 3, "ngClass", "click", 4, "ngIf"], ["id", "session-info-dd-end-session", "class", "dropdown-item d-xl-none", "jhiTranslate", "sessionChat.button.end", 3, "click", 4, "ngIf"], ["id", "session-info-dd-send-self-scan-link", "jhiTranslate", "sessionChat.button.sendSelfScan", 1, "dropdown-item", 3, "click"], ["id", "session-info-dd-display-resources", "jhiTranslate", "sessionChat.button.resources", 1, "dropdown-item", 3, "click"], ["class", "dropdown-item", "jhiTranslate", "sessionChat.button.organizationResources", 3, "ngClass", "click", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.bookASession", 1, "dropdown-item", 3, "disabled", "click"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.reschedule", 1, "dropdown-item", 3, "click"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.cancel", 1, "dropdown-item", 3, "click"], ["id", "session-info-dd-start-zoom-video-call", 1, "dropdown-item", 3, "click"], [2, "height", "25px", "width", "25px", "margin-right", "5px"], ["src", "../../../../../../../../../../../../content/images/internal-video-call-icon.svg", "alt", "talking.png", 1, "zoom-video-icon"], ["jhiTranslate", "sessionChat.button.internalVideoCall"], ["jhiTranslate", "sessionChat.button.preferred", 1, "parenthesis"], ["id", "session-info-dd-start-zoom-video-chat", 1, "dropdown-item", 3, "click"], ["src", "../../../../../../../../../../../../content/images/zoom-icon.svg", "alt", "talking.png", 1, "zoom-video-icon"], ["jhiTranslate", "sessionChat.button.zoom"], ["jhiTranslate", "sessionChat.button.backup", 1, "parenthesis"], ["id", "session-info-dd-start-jitsi-video-chat", 1, "dropdown-item", 3, "click"], ["src", "../../../../../../../../../../../../content/images/jitsi-icon.svg", "alt", "talking.png", 1, "jitsi-video-icon"], ["jhiTranslate", "sessionChat.button.jitsi"], ["id", "session-info-dd-extend-session", "jhiTranslate", "sessionChat.button.extend", 1, "dropdown-item", "d-xl-none", 3, "ngClass", "click"], ["id", "session-info-dd-end-session", "jhiTranslate", "sessionChat.button.end", 1, "dropdown-item", "d-xl-none", 3, "click"], ["jhiTranslate", "sessionChat.button.organizationResources", 1, "dropdown-item", 3, "ngClass", "click"], [1, "olha-theme", "schedule-session-modal"], ["icon", "times-circle", 1, "close", 3, "click"], [1, "main-body"], [1, "text-center"], [1, "header"], ["jhiTranslate", "inukaNgApp.offlineMessage.Book Session"], [1, "row", "mt-4", "justify-content-start"], [1, "col"], [3, "coach", "user", "sessionLanguage", "onCancel"], ["class", "olha-theme", 4, "ngIf"], [1, "olha-theme"], [1, "d-flex", "justify-content-end"], ["icon", "times-circle", 1, "mt-3", "mr-3", 2, "cursor", "pointer", 3, "click"], [1, "modal-body", "text-center"], ["jhiTranslate", "sessionChat.header.confirm"], ["jhiTranslate", "sessionChat.paragraph.end"], [1, "d-flex", "justify-content-center", "mt-4"], ["type", "button", "jhiTranslate", "sessionChat.button.end", 1, "btn", "btn-primary", "m-2", 3, "click"], ["type", "button", "jhiTranslate", "sessionChat.button.close", 1, "btn", "btn-secondary", "m-2", 3, "click"], [1, "olha-theme", "p-2", "pb-3"], [1, "modal-body", "text-center", "p-0"], ["jhiTranslate", "sessionChat.header.notShared"], ["jhiTranslate", "sessionChat.paragraph.askToShare"], ["type", "button", "jhiTranslate", "sessionChat.button.cancel", 1, "btn", "btn-secondary", "m-2", 3, "click"], ["type", "button", "jhiTranslate", "sessionChat.button.askToSee", 1, "btn", "btn-primary", "m-2", 3, "click"], [1, "olha-theme", "resources-content"], ["icon", "times-circle", 1, "mt-3", 2, "cursor", "pointer", 3, "click"], [1, "modal-body", "pt-0"], [3, "user", "resourceSelected"], ["class", "modal-body", 4, "ngIf"], [3, "titleText", "message", "dismissed", 4, "ngIf"], [1, "modal-body"], [1, "text-center", "my-4"], ["jhiTranslate", "sessionChat.header.reason"], ["inputAutoDirectionSwitch", "", "id", "session-chat-report-reason-input", "rows", "5", 1, "form-control", 3, "placeholder", "ngModel", "ngModelChange"], ["jhiTranslate", "sessionChat.paragraph.reason", 4, "ngIf"], ["id", "session-chat-report-submit", "type", "button", "jhiTranslate", "sessionChat.button.submit", 1, "btn-2", "btn-2-black", 3, "click"], ["jhiTranslate", "sessionChat.paragraph.reason"], [3, "titleText", "message", "dismissed"]], template: function SessionControlDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, SessionControlDropdownComponent_div_2_Template, 5, 0, "div", 2);
        i0.ɵɵtemplate(3, SessionControlDropdownComponent_div_3_Template, 3, 0, "div", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, SessionControlDropdownComponent_ng_container_5_Template, 3, 0, "ng-container", 4);
        i0.ɵɵtemplate(6, SessionControlDropdownComponent_ng_container_6_Template, 11, 7, "ng-container", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, SessionControlDropdownComponent_ng_template_7_Template, 9, 3, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(9, SessionControlDropdownComponent_ng_template_9_Template, 1, 1, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(11, SessionControlDropdownComponent_ng_template_11_Template, 12, 0, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(13, SessionControlDropdownComponent_ng_template_13_Template, 5, 1, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(15, SessionControlDropdownComponent_ng_template_15_Template, 2, 2, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isCoach());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isCoach());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("jhiHasAnyAuthority", "ROLE_USER");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("jhiHasAnyAuthority", "ROLE_COACH");
    } }, directives: [i6.NgbDropdown, i6.NgbDropdownToggle, i20.NgIf, i6.NgbDropdownMenu, i21.HasAnyAuthorityDirective, i22.FaIconComponent, i23.JhiTranslateDirective, i20.NgClass, i24.ScheduleSessionCoachComponent, i25.ResourcesForHelpComponent, i26.DefaultValueAccessor, i27.InputAutoDirectionSwitchDirective, i26.NgControlStatus, i26.NgModel, i28.ModalSuccessComponent], pipes: [i8.TranslatePipe], styles: [".resources-content[_ngcontent-%COMP%]{padding:0 20px 20px 20px}.horizontal-menu[_ngcontent-%COMP%]{z-index:1000;transform:rotate(90deg);position:absolute !important;top:-5px !important;right:5px !important;padding:5px !important;margin:5px !important}.vertical-menu[_ngcontent-%COMP%]{z-index:1000;position:absolute !important;top:20px !important;right:20px !important;padding:5px !important}.dropdown-toggle[_ngcontent-%COMP%]{cursor:pointer;color:#44a38d}.dropdown-toggle[_ngcontent-%COMP%]::after{display:none}.dropdown-menu[_ngcontent-%COMP%]{min-width:180px !important;top:6px !important;border:none !important;border-radius:10px !important;box-shadow:-3px 0px 30px rgba(0,0,0,.15)}.dropdown-menu[_ngcontent-%COMP%]:before{z-index:10000}.dropdown-item[_ngcontent-%COMP%]{background-color:#fff;color:#44a38d;font-weight:bold;display:flex;justify-content:start}.dropdown-item-disabled[_ngcontent-%COMP%]{background-color:#fff;color:#7cbfae !important;font-weight:bold}.dropdown-item[_ngcontent-%COMP%]:hover{background-color:#44a38d;color:#fff;font-weight:bold;text-decoration:underline}.dropdown-item-disabled[_ngcontent-%COMP%]:hover{font-weight:bold;text-decoration:underline}.video-icon[_ngcontent-%COMP%]{height:10px;width:14px;margin-right:10px;margin-bottom:4px}.jitsi-video-icon[_ngcontent-%COMP%], .zoom-video-icon[_ngcontent-%COMP%]{margin-right:10px;margin-bottom:4px}.parenthesis[_ngcontent-%COMP%]{margin-left:5px;color:#d3d3d3}.close[_ngcontent-%COMP%]{color:gray;font-size:20px;cursor:pointer;padding:10px}.main-body[_ngcontent-%COMP%]{margin:30px}.schedule-session-modal[_ngcontent-%COMP%]{max-height:800px;overflow-y:scroll;overflow-x:hidden}.table-header[_ngcontent-%COMP%]{background:#f7f4eb !important;border:none !important}table[_ngcontent-%COMP%], thead[_ngcontent-%COMP%], tbody[_ngcontent-%COMP%], th[_ngcontent-%COMP%]{border:none !important}.share-text[_ngcontent-%COMP%]{margin-left:5px;text-decoration:underline;color:#44a38b;font-weight:bold;cursor:pointer}table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{position:sticky;top:-1px}.angle-icon[_ngcontent-%COMP%]{height:12px;width:22px}.resource-header[_ngcontent-%COMP%]{cursor:pointer;background:#f7f4eb;padding:12px 15px 4px 15px;border-radius:5px}"], changeDetection: 0 });
